import { createAsyncThunk } from '@reduxjs/toolkit';
import { CompanySearchService } from '../../epics/search/company';
import { RegionSearchService } from '../../epics/search/region_services';
import { RentSearchService } from '../../epics/search/rent';
import { SellSearchService } from '../../epics/search/sell';
import { SortedListService } from '../../epics/search/sort';
import {
    bikeSearchKey,
    carSearchKey,
    commercialSearchKey,
    companySearchKey,
    partsSearchKey,
    placementSearchKey,
    rentSearchKey,
    searchCountKey,
    servicesSearchKey,
    sortedKey,
} from './searchKeys';

export const getSortedList = createAsyncThunk(
    sortedKey,
    async (values, thunkAPI) => {
        try {
            const response = await SortedListService.getSortedList(values);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getSearchListCount = createAsyncThunk(
    searchCountKey,
    async (values, thunkAPI) => {
        try {
            const response = await SortedListService.getSearchListCount(values);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getCompanySearchList = createAsyncThunk(
    companySearchKey,
    async (data, thunkAPI) => {
        try {
            const response =
                await CompanySearchService.getCompanySearchList(data);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getPartsSearchList = createAsyncThunk(
    partsSearchKey,
    async (data, thunkAPI) => {
        try {
            const response = await RegionSearchService.getPartsSearchList(data);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getPlacementSearchList = createAsyncThunk(
    placementSearchKey,
    async (data, thunkAPI) => {
        try {
            const response =
                await RegionSearchService.getPlacementSearchList(data);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getServicesSearchList = createAsyncThunk(
    servicesSearchKey,
    async (data, thunkAPI) => {
        try {
            const response =
                await RegionSearchService.getServicesSearchList(data);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getRentSearchList = createAsyncThunk(
    rentSearchKey,
    async (data, thunkAPI) => {
        try {
            const response = await RentSearchService.getRentSearchList(data);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getCarSearchList = createAsyncThunk(
    carSearchKey,
    async (data, thunkAPI) => {
        try {
            const response = await SellSearchService.getCarSearchList(data);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getBikeSearchList = createAsyncThunk(
    bikeSearchKey,
    async (data, thunkAPI) => {
        try {
            const response = await SellSearchService.getBikeSearchList(data);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getCommercialSearchList = createAsyncThunk(
    commercialSearchKey,
    async (data, thunkAPI) => {
        try {
            const response =
                await SellSearchService.getCommercialSearchList(data);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);
